import React, {FunctionComponent} from 'react';

interface Props {
    errors: string[];
}

const ErrorList: FunctionComponent<Props> = (props) => {

    return (
        <ul className="message-box errors">
            { props.errors.map(error => (
                <li key={error}>{error}</li>
            )) }
        </ul>
    );
};

export default ErrorList;
